import { Typography } from "@mui/material";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import ProfileType from "../../interfaces/profile";

export default function ExpiryBadge({ profile }: { profile?: ProfileType }) {
	const { t } = useTranslation();
	if (!profile?.expires_at && !profile?.is_expired) return null;

	const expiresAt = dayjs(profile.expires_at);
	const expired = profile.is_expired || !expiresAt.isValid() || expiresAt.isBefore(dayjs());
	const daysLeft = Math.ceil(expiresAt.diff(dayjs(), 'day', true));

	let color = '#2e7d32';
	let blink = '';
	if (expired || daysLeft <= 1) {
		color = '#d32f2f';
	} else if (daysLeft <= 3) {
		color = '#ed6c02';
		blink = 'expiry-blink';
	}

	const text = expired
		? t('expiry_expired')
		: `${t('expiry_valid_until', { date: expiresAt.toDate().toLocaleDateString('fa-IR') })} (${t('expiry_days_left', { count: daysLeft })})`;

	return (
		<Typography component="span" className={`${blink} text-xs font-bold bg-white/90 rounded px-1`} style={{ color }}>
			{text}
		</Typography>
	);
}
